import { Box, Stack, Typography } from "@mui/material";
import { useAppSelector } from "store/store";
import { truncate } from "utils/HelperUtil";
import SuccessLogo from "assets/success.svg";

const SessionDisconnectModal = () => {
  const { activeAccount } = useAppSelector((state) => state.app);
  return (
    <Box
      sx={{
        background: "white",
        overflowY: "scroll",
        width: "40%",
        height: "60%",
        // transform: "translateX(80%) translateY(20%)",
        padding: "10px",
        borderRadius: "4px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        // opacity: "0",
      }}
    >
      <Stack
        gap={2}
        sx={{ marginTop: "25px" }}
        direction="column"
        alignItems={"center"}
        justifyContent={"center"}
      >
        <Typography
          variant="h4"
          color="#121212"
          fontSize="22px"
          fontWeight={600}
        >
          @{activeAccount?.accountName}
        </Typography>

        <Typography
          variant="body1"
          color="#67686C"
          fontSize="20px"
          fontWeight={400}
        >
          {truncate(activeAccount?.smartAccountAddress, 16)}
        </Typography>

        <img
          src={SuccessLogo}
          style={{ marginTop: "20px", marginBottom: "20px" }}
        />

        <Typography
          variant="h4"
          color="#121212"
          fontSize="22px"
          fontWeight={600}
        >
          Disconnecting Successfull
        </Typography>

        <Typography
          variant="body1"
          color="#121212"
          fontSize="20px"
          fontWeight={500}
        >
          Your now disconnected
        </Typography>
      </Stack>
    </Box>
  );
};

export default SessionDisconnectModal;
